// ======================================================================
// File Name       : ServiceGroupSuperUserContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Col, Form, FormControl, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as modalActions from '../../actions/ModalAction';
import * as serviceGroupActions from '../../actions/ServiceGroupAction';
import MessageSearch from '../../components/MessageSearch';
import CustomButton from '../../components/button/CustomButton';
import ModalWrapper from '../../components/modal/ModalWrapper';
import ServiceGroupSuperUserList from '../../components/serviceGroup/ServiceGroupSuperUserList';
import { RETURN_MAX_NUM } from '../../constants';
import { REDIRECT_MODAL } from '../../constants/ServiceGroupConstants';
import ServiceGroupSuperUserEditList from '../../components/serviceGroup/ServiceGroupSuperUserEditList';
import { hideLoading, showLoading } from '../../utils/PageUtils';

class ServiceGroupSuperUserContainer extends Component {
  constructor() {
    super();
    this.state = {
      checkedSuperUser: [],
      checkedSuperUserOnPage: [],
      isAllowShowSearchMessage: false,
      isInit: true,
    };
    this.handleNextBtn = this.handleNextBtn.bind(this);
    this.handleBackBtn = this.handleBackBtn.bind(this);
    this.handleSearchConditionChange = this.handleSearchConditionChange.bind(this);
    this.handleSearchBtn = this.handleSearchBtn.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSuperUserCheck = this.handleSuperUserCheck.bind(this);
    this.handleCheckAll = this.handleCheckAll.bind(this);
    this.handleAddBtn = this.handleAddBtn.bind(this);
    this.handleRemoveUser = this.handleRemoveUser.bind(this);
    this.handleRemoveAll = this.handleRemoveAll.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.hideModal = this.hideModal.bind(this);
  }

  componentDidMount() {
    const { serviceGroup } = this.props;
    !serviceGroup.searchResultSuperUser.searched && this.handleSearchBtn();
  }

  handleNextBtn() {
    const { dispatch, modalId } = this.props;
    dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].OK));
  }

  handleBackBtn() {
    const { dispatch, modalId } = this.props;
    dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].CANCEL));
  }

  handleSearchConditionChange({ target }) {
    const { dispatch } = this.props;
    const { name, value } = target;
    dispatch(
      serviceGroupActions.editingSuperUserSearchCondition({
        [name]: value,
      }),
    );
  }

  handleSearchBtn() {
    const { dispatch, serviceGroup, authedUser } = this.props;
    const { loginId, superuserName } = serviceGroup.searchConditionSuperUser;
    this.setState({ checkedSuperUserOnPage: [], checkedSuperUser: [], isAllowShowSearchMessage: false, isInit: false },
      () => {
        const param = {
          searchInfo: {
            loginIdList: loginId ? [loginId] : [],
            superuserName,
            startPosition: 0,
            returnMaxNum: RETURN_MAX_NUM,
            enterpriseCd: authedUser.enterpriseCd,
          },
        };
        dispatch(showLoading());
        dispatch(
          serviceGroupActions.getServiceGroupSuperUserList(param),
        ).then(() => {
          if (!this.state.isInit) {
            this.setState({ isAllowShowSearchMessage: true });
          }
          dispatch(hideLoading());
        });
      },
    );
  }

  handlePageChange(start) {
    this.setState({ checkedSuperUserOnPage: [], checkedSuperUser: [] });
    const { dispatch, serviceGroup, authedUser } = this.props;
    const { loginId, superuserName } = serviceGroup.searchConditionSuperUser;
    const param = {
      searchInfo: {
        loginIdList: loginId ? [loginId] : [],
        superuserName,
        startPosition: start,
        returnMaxNum: RETURN_MAX_NUM,
        enterpriseCd: authedUser.enterpriseCd,
      },
    };
    dispatch(showLoading());
    dispatch(
      serviceGroupActions.getServiceGroupSuperUserList(param),
    ).then(() => {
      dispatch(hideLoading());
    });
  }

  handleSuperUserCheck(event) {
    const { value } = event.target;
    const checkedSuperUser = [...this.state.checkedSuperUser];
    const checkedSuperUserOnPage = [...this.state.checkedSuperUserOnPage];
    const pos = checkedSuperUser.indexOf(value);
    pos < 0 ? checkedSuperUser.unshift(value) : checkedSuperUser.splice(pos, 1);
    const pos2 = checkedSuperUserOnPage.indexOf(value);
    pos2 < 0 ? checkedSuperUserOnPage.unshift(value) : checkedSuperUserOnPage.splice(pos2, 1);
    this.setState({ checkedSuperUser, checkedSuperUserOnPage });
  }

  handleCheckAll() {
    const { serviceGroup } = this.props;
    const searchResultSuperUser = serviceGroup.searchResultSuperUser.allSecernIds.reduce((acc, cur) => {
      const superuser = serviceGroup.searchResultSuperUser.bySecernId[cur];
      if (!serviceGroup.editingServiceGroupSuperUser[cur] && !superuser.rootFlag) {
        acc.push(cur);
      }
      return acc;
    }, []);
    const { checkedSuperUserOnPage, checkedSuperUser } = this.state;
    if (this.state.checkedSuperUserOnPage.length === searchResultSuperUser.length) {
      // uncheckAll
      checkedSuperUserOnPage.map((userSecernId) => {
        const pos = checkedSuperUserOnPage.indexOf(userSecernId);
        if (checkedSuperUser.indexOf(userSecernId) > -1) {
          checkedSuperUser.splice(pos, 1);
        }
        return null;
      });
      this.setState({ checkedSuperUserOnPage: [], checkedSuperUser: [] });
      return;
    }
    // checkAll
    searchResultSuperUser.map((userSecernId) => {
      if (checkedSuperUser.indexOf(userSecernId) < 0) {
        checkedSuperUser.unshift(userSecernId);
      }
      return null;
    });
    this.setState({ checkedSuperUserOnPage: [...searchResultSuperUser], checkedSuperUser });
  }

  handleAddBtn() {
    const { dispatch } = this.props;
    this.scrollToBottom();
    dispatch(serviceGroupActions.editingServiceGroupSuperUser({ addedList: this.state.checkedSuperUser }));
  }

  handleRemoveUser(userSecernId) {
    const { dispatch } = this.props;
    const { checkedSuperUser, checkedSuperUserOnPage } = this.state;
    const pos = checkedSuperUser.indexOf(userSecernId);
    if (pos >= 0) {
      checkedSuperUser.splice(pos, 1);
    }
    const pos2 = checkedSuperUserOnPage.indexOf(userSecernId);
    if (pos2 >= 0) {
      checkedSuperUserOnPage.splice(pos2, 1);
    }
    this.setState({
      checkedSuperUser,
      checkedSuperUserOnPage,
    }, () => {
      dispatch(serviceGroupActions.editingServiceGroupSuperUser({ removedSecern: userSecernId }));
    });
  }

  handleRemoveAll() {
    const { dispatch } = this.props;
    this.setState({
      checkedSuperUser: [],
      checkedSuperUserOnPage: [],
    }, () => {
      dispatch(serviceGroupActions.editingServiceGroupSuperUser({ removedAll: true }));
    });
  }

  getModalOptions() {
    return {
      title: 'サービスグループに所属する管理ユーザーを選択してください',
      footerBtns: [
        { name: '戻る', onClick: this.handleBackBtn, variant: 'default' },
        { name: '次へ', onClick: this.handleNextBtn, variant: 'primary' },
      ],
    };
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  scrollToBottom() {
    const node = document.getElementById('scroll-table-superuser');
    node.scrollIntoView({ behavior: 'smooth' });
  }

  hideModal() {
    this.props.hideModal();
  }

  render() {
    const { serviceGroup } = this.props;
    const { searchConditionSuperUser, searchResultSuperUser, editingServiceGroupSuperUser } = serviceGroup;

    return (
      <ModalWrapper {...this.getModalOptions()} hideModal={this.hideModal} dialogClassName="group-dialog">
        <div>
          <div className="max-width-950">
            <MessageSearch
              recordNum={searchResultSuperUser ? searchResultSuperUser.recordNum : 0}
              resultList={searchResultSuperUser ? searchResultSuperUser.allSecernIds : []}
              isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
              dismissMessage={this.dismissMessage}
            />
            <Form className='form-horizontal'>
              <Form.Group className="form-info padding-right-15">
                <Col as={Form.Label} sm={3}>管理ユーザー名</Col>
                <Col sm={9}>
                  <FormControl
                    name="superuserName"
                    value={searchConditionSuperUser.superuserName || ''}
                    onChange={this.handleSearchConditionChange}
                  />
                </Col>
              </Form.Group>
              <Form.Group className="form-info padding-right-15">
                <Col as={Form.Label} sm={3}>ログインID</Col>
                <Col sm={9}>
                  <FormControl
                    name="loginId"
                    value={searchConditionSuperUser.loginId || ''}
                    onChange={this.handleSearchConditionChange}
                  />
                </Col>
              </Form.Group>
              <Row>
                <Col sm={12} className="text-center padding-top-10">
                  <CustomButton
                    btnStyle="btn btn-primary btn-96"
                    handleClick={this.handleSearchBtn}
                    text="検索"
                    iconClass="bi bi-search"
                  />
                </Col>
              </Row>
            </Form>
            <ServiceGroupSuperUserList
              searchResultSuperUser={searchResultSuperUser}
              editingServiceGroupSuperUser={editingServiceGroupSuperUser}
              checkedSuperUserOnPage={this.state.checkedSuperUserOnPage}
              handlePageChange={this.handlePageChange}
              handleCheckAll={this.handleCheckAll}
              handleSuperUserCheck={this.handleSuperUserCheck.bind(this)}
              handleAddBtn={this.handleAddBtn}
            />
            <ServiceGroupSuperUserEditList
              editingServiceGroupSuperUser={editingServiceGroupSuperUser}
              handleRemoveAll={this.handleRemoveAll}
              handleRemoveUser={this.handleRemoveUser}
              handleBackBtn={this.handleBackBtn}
              handleNextBtn={this.handleNextBtn}
            />
          </div>
        </div>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { serviceGroup, authority, authed: { authedUser } } = state;
  return { serviceGroup, authority: authority.authorityInfo, authedUser };
};
export default connect(mapStateToProps)(ServiceGroupSuperUserContainer);
